import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../common/Header';
import Navigation from '../common/Navigation';
import ReceiptModal from '../common/ReceiptModal';
import OrderNotification from '../common/OrderNotification';

const MainLayout = () => {
  const [showReceipt, setShowReceipt] = useState(false);
  const [lastReceipt, setLastReceipt] = useState(null);

  const handleShowReceipt = (receipt) => {
    setLastReceipt(receipt);
    setShowReceipt(true);
  };

  return (
    <div className="h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex justify-center">
      <div className="w-full lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl flex flex-col h-full shadow-xl">
        <div className="flex-shrink-0">
          <Header />
        </div>
        <div className="flex-shrink-0">
          <Navigation />
        </div>
        <div className="flex-1 overflow-hidden">
          <div className="h-full px-4 py-4 overflow-y-auto">
            <Outlet context={{ onShowReceipt: handleShowReceipt }} />
          </div>
        </div>
      </div>

      {showReceipt && (
        <ReceiptModal
          receipt={lastReceipt}
          onClose={() => setShowReceipt(false)}
        />
      )}

      <OrderNotification />
    </div>
  );
};

export default MainLayout;